import {Grid, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import React, {type ReactElement, useState} from 'react'

import {Body, NumberInput, TextInput, ToggleTitle} from '../../../../components/desktop'
import {InputSkeleton} from '../../../../components/LayoutSkeleton/components/InputSkeleton/index@desktop'
import {useConfigContext} from '../../../../contexts'
import {getPointLocation} from '../../lib'
import {usePrefetchAddress} from '../AddressWidget/hooks/use-prefetch-address'
import {SuggestDesktop} from '../Suggest'
import type {Props} from './Address.types'
import * as classes from './Details.classes'

export function AddressDetails({isSource, name, pointId}: Props): ReactElement {
  const i18n = useI18n()
  const [isOpened, setIsOpened] = useState(false)
  const {initialProps, location} = useConfigContext()
  const pointLocation = getPointLocation({initialProps, location, isSource})
  const {isLoading} = usePrefetchAddress(name, isSource, pointId, pointLocation)

  if (isLoading) {
    return <InputSkeleton />
  }

  return (
    <Body
      lead={
        <>
          <Typography group="tight" mt="s" thickness="medium" variant="body2">
            {i18n('cargo.create.address.address', 'Адрес')}
          </Typography>
          <ToggleTitle
            isOpened={isOpened}
            onClick={() => {
              setIsOpened(prev => !prev)
            }}
            title={i18n('cargo.create.address.details', 'Детали')}
          />
        </>
      }
      tail={
        <Grid container>
          <Grid xs={12} item>
            <SuggestDesktop coordinates={pointLocation || location} isSource={isSource} name={name} />
          </Grid>
          {isOpened && (
            <Grid xs={12} item>
              <Grid size="s" container>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.entrance', 'Подъезд')}
                    name={`${name}.entrance`}
                    size="l"
                    variant="line"
                  />
                </Grid>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.code', 'Домофон')}
                    name={`${name}.code`}
                    size="l"
                    variant="line"
                  />
                </Grid>
                <Grid xs={3} item>
                  <NumberInput
                    label={i18n('bdui.address.input.floor', 'Этаж')}
                    name={`${name}.floor`}
                    size="l"
                    variant="line"
                  />
                </Grid>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.apartment', 'Кв./офис')}
                    name={`${name}.apartment`}
                    size="l"
                    variant="line"
                  />
                </Grid>
              </Grid>
              <Grid xs={12} item>
                <TextInput
                  className={classes.multiline}
                  label={i18n('bdui.address.input.comment', 'Комментарий для курьера')}
                  name={`${name}.comment`}
                  size="l"
                  variant="line"
                  multiline
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      }
    />
  )
}
